import { render, staticRenderFns } from "./CameraTestBase.vue?vue&type=template&id=5909a236&scoped=true&"
import script from "./CameraTestBase.vue?vue&type=script&lang=js&"
export * from "./CameraTestBase.vue?vue&type=script&lang=js&"
import style0 from "./CameraTestBase.vue?vue&type=style&index=0&id=5909a236&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5909a236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5909a236')) {
      api.createRecord('5909a236', component.options)
    } else {
      api.reload('5909a236', component.options)
    }
    module.hot.accept("./CameraTestBase.vue?vue&type=template&id=5909a236&scoped=true&", function () {
      api.rerender('5909a236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/test/camera/CameraTestBase.vue"
export default component.exports